import { render, staticRenderFns } from "./MMChoiceMobile.vue?vue&type=template&id=ada465f2"
import script from "./MMChoiceMobile.vue?vue&type=script&lang=js"
export * from "./MMChoiceMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports